import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { default as Home } from './views/Landing/Home/index';
import PageWrapper from './components/PageWrapper/PageWrapper';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import './temp.css';
const promise = loadStripe(
	'pk_live_51I0f5GJCJMCt2tBlKnC70jHbyEWOJDIriqwJYU4NIQD0IQSBziDlMHZRiXi4leg5SxJmhJImfy6iWG36Cj7znGyV00hGUiFoUM'
);
function App() {
	return (
		<div className="App">
			<PageWrapper>
				<Router>
					<div style={{ position:'absolute',zIndex:999 ,padding:'1rem'}}>
						<blockquote style={{ display: 'flex' }}>
							<div class="reviewer-meta" style={{margin:0}}>
								<img src="https://www.johnyacoub.live/wp-content/uploads/2021/03/DAC615CA-7766-4488-A85D-3C8E9A47BEE6_1_201_a-300x194.jpeg" alt="" />
								<div class="reviwer-name" style={{textAlign:'center'}}>
									<h2 class="name" style={{margin:0}}>John Yacoub</h2>
									<span>Web Developer</span>
								</div>
							</div>
						</blockquote>
					</div>

					<Switch>
						<Route exact path="/">
							<Elements stripe={promise}>
								<Home />
							</Elements>
						</Route>
						<Route path="*" render={() => <div>404</div>} />
					</Switch>
				</Router>
			</PageWrapper>
		</div>
	);
}

export default App;
